/* @flow */

export default {
  button: {
    padding: 0,
    background: 'none',
    minHeight: 0,
  },
};
